import { Elm } from './generated/elm.js'
import '../styles/main.css'

// The API origin is baked in at build time. Set VITE_API_BASE_URL in the
// environment (or apps/frontend/.env) to point a build at a deployed backend;
// without it we assume the local NestJS server from apps/backend.
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'

// The session lives in localStorage rather than sessionStorage: a shopper
// expects to still be signed in tomorrow, unlike an admin on a shared machine.
// Reading it can throw in a locked-down browser, so a failure means "no
// session" rather than a blank page.
const SESSION_KEY = 'sarsilver.token'

let token = null
try {
  token = localStorage.getItem(SESSION_KEY)
} catch (_) {
  token = null
}

// The visitor's own clock. Baking the year in at build time means the footer
// is wrong from the first of January until somebody redeploys.
const currentYear = new Date().getFullYear()

const app = Elm.Main.init({
  node: document.getElementById('app'),
  flags: { apiBaseUrl, token, currentYear }
})

// Elm sends the token to keep, or null to forget it. It is only ever a claim:
// Elm trades it for the user it belongs to at startup and clears it here if
// the server refuses.
app.ports.storeSession.subscribe((value) => {
  try {
    if (value === null) {
      localStorage.removeItem(SESSION_KEY)
    } else {
      localStorage.setItem(SESSION_KEY, value)
    }
  } catch (_) {
    // Storage unavailable: the session simply does not survive a reload.
  }
})
